(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("larkplayer"));
	else if(typeof define === 'function' && define.amd)
		define(["larkplayer"], factory);
	else if(typeof exports === 'object')
		exports["larkplayer-play-muted"] = factory(require("larkplayer"));
	else
		root["larkplayer-play-muted"] = factory(root["larkplayer"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_larkplayer__) {
return 